import { KILO } from '../../constants/KILO_THEME'

/** Shared form tokens for onboarding steps — references CSS vars from index.css. */
export const ONBOARDING = {
  input:
    'w-full rounded-2xl border border-kilo-line bg-kilo-alt px-4 py-3 text-sm text-kilo-text placeholder-kilo-soft outline-none transition focus:border-kilo-accent/50',
  select:
    'w-full rounded-2xl border border-kilo-line bg-kilo-alt px-4 py-3 text-sm text-kilo-text outline-none transition focus:border-kilo-accent/50',
  textarea:
    'w-full rounded-2xl border border-kilo-line bg-kilo-alt px-4 py-3 text-sm text-kilo-text placeholder-kilo-soft outline-none transition focus:border-kilo-accent/50',
  range: `h-1.5 w-full cursor-pointer appearance-none rounded-full ${KILO.progressTrack} accent-kilo-accent`,
  label:      'text-sm font-medium text-kilo-muted',
  fieldGroup: 'flex flex-col gap-3',
  subtitle:   'mt-2 text-kilo-muted',
  heading:    'text-2xl font-semibold text-kilo-text',
  subheading: 'text-lg font-semibold text-kilo-text',
  chipActive:   'border-kilo-accent/50 bg-kilo-accent/10 text-kilo-text',
  chipInactive: 'border-kilo-line bg-kilo-nested text-kilo-muted hover:border-kilo-border',
  choiceActive:   'border-kilo-accent/50 bg-kilo-accent/10 ring-1 ring-kilo-accent/30',
  choiceInactive: 'border-kilo-line bg-kilo-nested hover:border-kilo-border',
  card:       'rounded-2xl border border-kilo-line bg-kilo-nested/80',
  panel:      'rounded-2xl border border-kilo-line bg-kilo-nested p-4',
  reviewCard: 'rounded-2xl border border-kilo-line bg-kilo-alt/50 p-4',
  reviewHeading: 'font-semibold text-kilo-text',
  reviewValue: 'text-kilo-text',
  error:      'rounded-2xl border border-kilo-danger/30 bg-kilo-danger-bg px-4 py-3 text-sm text-kilo-danger',
  infoSuccess: 'rounded-2xl border border-kilo-accent/30 bg-kilo-accent/10 px-4 py-3 text-sm text-kilo-text',
  infoWarning: 'rounded-2xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm text-amber-700 dark:text-amber-200',
  phaseComplete: 'border-kilo-line bg-kilo-nested/80 opacity-80',
  phasePending: 'border-kilo-line bg-kilo-nested/60 opacity-50',
  muted:      'text-kilo-muted',
  mutedSoft:  'text-kilo-soft',
} as const

export function onboardingChipClass(active: boolean): string {
  return `rounded-2xl border-2 px-4 py-2 text-sm font-medium transition ${
    active ? ONBOARDING.chipActive : ONBOARDING.chipInactive
  }`
}

export function onboardingChoiceClass(active: boolean): string {
  return `rounded-2xl border-2 p-5 text-left transition ${
    active ? ONBOARDING.choiceActive : ONBOARDING.choiceInactive
  }`
}

export function onboardingFieldControlClass(base: string, invalid: boolean): string {
  return invalid ? `${base} border-kilo-danger/60 bg-kilo-danger-bg/10` : base
}
